var React = require('react');

function SidebarCircle02Inline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"8","height":"8","fill":"white","key":0}),React.createElement("path",{"d":"M2.64994 1C1.01282 1.69489 1 2.14102 1 3.65868C1 4.48184 1.00001 5.43666 1.6722 6.05148C2.25354 6.58322 4.44044 7.45302 5.81231 6.71615C6.63497 6.27428 7.44705 4.33821 6.71366 3.45189C5.64365 2.15874 4.55269 1.53174 2.64994 1.53174","stroke":"#7F879D","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SidebarCircle02Inline.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = SidebarCircle02Inline;

SidebarCircle02Inline.default = SidebarCircle02Inline;
